import { render, staticRenderFns } from "./PrecoOrStockPrices.vue?vue&type=template&id=669f39f2"
import script from "./PrecoOrStockPrices.vue?vue&type=script&lang=js"
export * from "./PrecoOrStockPrices.vue?vue&type=script&lang=js"
import style0 from "./PrecoOrStockPrices.vue?vue&type=style&index=0&id=669f39f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports